import { CircularProgress } from "@mui/material";
import { forwardRef } from "react";

export const FieldLoadingIcon = forwardRef((props, ref) => (
  <CircularProgress
    {...props}
    ref={ref}
    size={14}
    sx={{ mx: 0.75, color: "text.disabled" }}
  />
));
